/* eslint-disable */
import $ from 'jquery'

const SELECTORS = {
    searchInput: '#SearchInput',
    suggestionsContainer: '[data-searchform-suggestions]',
    toggleBtn: '[data-search-toggle-btn]',
    toggleBtnIconOpen: '[data-search-toggle-btn-icon-open]',
    toggleBtnIconClose: '[data-search-toggle-btn-icon-close]',
    closeBtn: '[data-search-close-btn]'
}

const CLASSES = {
    searchOpen: 'search-open'
}

class Search {
    constructor() {
        this.state = {
            isOpen: false,
            lastTerm: ''
        }

        this.$input = $(SELECTORS.searchInput)
        this.$toggleBtn = $(SELECTORS.toggleBtn)
        this.$toggleBtnIconOpen = $(SELECTORS.toggleBtnIconOpen)
        this.$toggleBtnIconClose = $(SELECTORS.toggleBtnIconClose)
        this.$closeBtn = $(SELECTORS.closeBtn)
        this.$suggestionsContainer = $(SELECTORS.suggestionsContainer)

        this.activeRequest = null
        this.maxSuggestions = 10
        this.fetchSuggestions = this.fetchSuggestions.bind(this)

        this.bindEvents()
    }

    bindEvents() {
        const $body = $(document.body)

        this.$toggleBtn.on('click', () => {
            this.state.isOpen = !this.state.isOpen
            $body.toggleClass(CLASSES.searchOpen)

            if (this.state.isOpen) {
                this.$toggleBtnIconOpen.hide()
                this.$toggleBtnIconClose.show()
                this.$input.focus()
            } else {
                this.$toggleBtnIconOpen.show()
                this.$toggleBtnIconClose.hide()
            }
        })

        this.$closeBtn.on('click', () => {
            this.state.isOpen = false
            $body.removeClass(CLASSES.searchOpen)
        })

        this.$input.on('keyup change', this.fetchSuggestions)

        $body.on('click', () => {
            this.$suggestionsContainer.hide()
        })
    }

    fetchSuggestions() {
        const term = this.$input.val()
        const searchURL = `/search?type=product&q=${term}`

        if (!term.length) {
            this.$suggestionsContainer.hide()
        }

        if (term.length > 3 && term !== this.state.lastTerm) {
            // Saving old query.
            this.state.lastTerm = term
            // Killing any Ajax request that's currently being processed.
            if (this.activeRequest != null) {
                this.activeRequest.abort()
            }
            // make a new request
            this.activeRequest = $.getJSON(`${searchURL}&view=json`, (data) =>
                this.renderSuggestions(data, searchURL)
            )
        }
    }

    renderSuggestions(data, searchURL) {
        const { results, results_count } = data
        const $resultsList = $('<ul class="autosuggest">')

        if (results_count === 0) {
            this.$suggestionsContainer.hide()
            return
        }

        // prettier-ignore
        const $results = results.slice(0, this.maxSuggestions).map(item => $(`
            <li class="autosuggest__item">
                <a href="${item.url}" class="autosuggest__link">
                    <img src="${item.thumbnail}" class="autosuggest__image" />
                    <span class="autosuggest__title">${item.title}</span>
                </a>
            </li>
        `))
        $resultsList.append($results)

        // The Ajax request will return at the most 10 results.
        // If there are more than 10, let's link to the search results page.
        if (results_count > this.maxSuggestions) {
            $resultsList.append(
                `<li class="autosuggest__item">
                    <a class="autosuggest__more" href="${searchURL}">Alle Ergebnisse (${results_count})</a>
                </li>`
            )
        }

        this.$suggestionsContainer.empty().append($resultsList).show()
    }
}

$(document).ready(() => new Search())
